import R from "ramda";

import {
  HEAD,
  HEAD_CUT,
  SCALE_HEAD_CUT,
  drawHead,
  drawHeadMask,
  drawHeadCut,
  getHeadFromHeadCut,
  canvasToImage,
  initCanvas,
} from "utils/canvasUtils";
import { gVisionToNewHead } from "utils/gVisionUtils";
import FacePresenter from "presenters/FacePresenter";

export const intersectLayers = (face, svgImage, type = "image") => {
  return ["destination-over", "source-in"].map((operation) => {
    const [cnv, ctx] = initCanvas(HEAD);
    ctx.drawImage(svgImage, 0, 0);
    ctx.globalCompositeOperation = operation;
    ctx.drawImage(face, 0, 0);
    ctx.globalCompositeOperation = "destination-in";
    ctx.drawImage(face, 0, 0);
    if (type === "canvas") return cnv;
    return canvasToImage(cnv);
  });
};

export const headCutCanvas = ({ image, gVisionData, scale }) => {
  const headObject = gVisionToNewHead(gVisionData, image);
  const [cnv, ctx] = initCanvas(HEAD_CUT);
  drawHeadCut(ctx, image, headObject, scale);

  return cnv;
};

export const headCanvas = ({ image, gVisionData, headMask, transforms = {} }) => {
  const [canvas, context] = initCanvas(HEAD);
  const headObject = gVisionToNewHead(gVisionData, image);

  if (transforms && !R.isEmpty(transforms)) {
    const headCut = headCutCanvas({ image, gVisionData, scale: SCALE_HEAD_CUT });
    const cnv = getHeadFromHeadCut(headCut, headMask, transforms);
    return cnv;
  }

  drawHead(context, image, headObject);
  drawHeadMask(context, headMask);

  return canvas;
};

export const zeroFace = {
  scale: 1.0,
  angle: 0.0,
  offset: { x: 0, y: 0 },
};

export const getRandomFace = (faces) => faces[Math.floor(Math.random() * faces.length)];

export const faceCreateAttributes = (key, svg) => {
  return {
    data: {
      attributes: {
        asset: {
          head_key: key,
        },
      },
      relationships: {
        jaw: {
          data: {
            attributes: {
              svg,
            },
            type: "jaws",
          },
        },
      },
      type: "heads",
    },
  };
};

export const faceUpdateAttributes = (personSlug, faceSlug) => {
  return {
    data: {
      id: faceSlug,
      type: "heads",
      relationships: {
        person: {
          data: {
            id: personSlug,
            type: "people",
          },
        },
      },
    },
  };
};

export const faceUpdateJawAttributes = (face, jawSvg) => {
  return {
    data: {
      attributes: {
        asset: FacePresenter.asset(face),
        createdAt: FacePresenter.createdAt(face),
        default: FacePresenter.default(face),
      },
      id: FacePresenter.id(face),
      relationships: {
        jaw: {
          data: {
            attributes: {
              svg: jawSvg,
            },
            type: "jaws",
          },
          person: {
            data: FacePresenter.person(face),
          },
        },
      },
      type: "heads",
    },
  };
};
